import generateBasicEntityActions from "./generateBasicEntityActions";

const myPositionActions = generateBasicEntityActions(
  "myClientPositions",
  "myClientPosition",
);

export default myPositionActions;
